// @core/api/endpoints/subscription/update_plan.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  PlanResponse,
  UpdatePlanRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Update subscription plan
 * Updates an existing subscription plan. Changes to pricing only affect new subscriptions; existing subscriptions retain their original terms.
 */
export async function UpdatePlan(
  plan_id: string,
  data: UpdatePlanRequest,
  options?: RequestOptions
): Promise<PlanResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/plans/:plan_id`;
  requestPath = requestPath.replace(':plan_id', encodeURIComponent(plan_id));
  const requestOptions = options;
  return client.put<PlanResponse>(requestPath, data, requestOptions);
}
